import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import Spinner from "../../Component/Spinner/Spinner";
import CheckOut from './Buyer/CheckOut';
import { AuthContext } from '../../Context/UseContext';
import { useDbUser } from '../../hooks/useUser';
import useTitle from '../../hooks/useTitle';
import ErrorMessage from '../Shared/ErrorMessage/ErrorMessage';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const Payment = () => {
    const {id} = useParams();
    const { user, loading } = useContext(AuthContext);
    const [dbUser, isDbUserLoading] = useDbUser(user?.email);
    const [isPaymentLoading, setIsPaymentLoading] = useState(false);
    const [bookingProduct, setBookingProduct] = useState(null);
    const [errorMessages, setErrorMessages] = useState("");

    useEffect(() => {
        if (!dbUser) return;
            setIsPaymentLoading(true);
            fetch(`${process.env.REACT_APP_API_URL}/booking/${dbUser?.email}/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            })
            .then(res => res.json())
            .then((data) => {
                if(data.success){
                    setBookingProduct(data.data);
                    setIsPaymentLoading(false);
                    setErrorMessages("");
                } else {
                    setIsPaymentLoading(false);
                    setErrorMessages(data.message);
                }
            })
            .catch((err) => {
                setIsPaymentLoading(false);
                setErrorMessages(err.message);
            })
    }, [dbUser, id]);

    useTitle(`Pay for ${bookingProduct?.product}`);
    if ( isPaymentLoading || isDbUserLoading || loading) {
        return <Spinner/>
    }
    if (errorMessages) {
        return <ErrorMessage error={errorMessages}/>
    }
    return (
        <>
        {
            bookingProduct && (
                    <div className='flex flex-col items-center'>
                        <h3 className="text-3xl">Payment for {bookingProduct?.product}</h3>
                        <p className="text-xl">Please pay <strong>${bookingProduct?.price}</strong> for your Product</p>
                        <div className='w-96 my-12'>
                            <Elements stripe={stripePromise}>
                                <CheckOut
                                    booking={bookingProduct}
                                />
                            </Elements>
                        </div>
                    </div>
            )
        }
        </>
    );
};

export default Payment;